import { IDisplayTicket } from '../interfaces/IDisplayTicket';

/**
 * @description - Compara duas versões do mesmo ticket pelo `updatedAt`.
 *
 * Sem data em algum dos lados não há como decidir, e vence o candidato — que é
 * o comportamento de "o último ganha".
 */
function isNewer(candidate: IDisplayTicket, current: IDisplayTicket): boolean {
  const candidateAt = candidate.updatedAt
    ? new Date(candidate.updatedAt).getTime()
    : NaN;
  const currentAt = current.updatedAt
    ? new Date(current.updatedAt).getTime()
    : NaN;

  if (Number.isNaN(candidateAt) || Number.isNaN(currentAt)) return true;

  return candidateAt >= currentAt;
}

/**
 * @description
 * - Remove tickets repetidos pelo id, mantendo a posição da primeira ocorrência
 *   e a versão mais recente pelo `updatedAt`.
 *
 * - A lista de tickets é alimentada por três fontes que podem entregar o mesmo
 *   ticket mais de uma vez: a carga inicial, a paginação por scroll e os
 *   eventos de socket. Sem esta rede de segurança o mesmo ticket é renderizado
 *   como dois cards idênticos na cozinha.
 *
 * - A ordem de chegada não diz qual versão é a mais nova: uma resposta HTTP
 *   iniciada antes de um evento de socket pode chegar depois dele, e ficar com
 *   a última faria o card regredir de status. Por isso a escolha é pela data,
 *   não pela posição na lista.
 *
 * @param tickets - lista que pode conter repetições
 * @returns IDisplayTicket[] - lista sem ids repetidos
 */
export function dedupeTicketsById(tickets: IDisplayTicket[]): IDisplayTicket[] {
  const deduped: IDisplayTicket[] = [];
  const indexById: Record<string, number> = {};

  (tickets || []).forEach((ticket) => {
    if (!ticket) return;

    const existingIndex = indexById[ticket.id];

    if (existingIndex === undefined) {
      indexById[ticket.id] = deduped.length;
      deduped.push(ticket);
      return;
    }

    if (isNewer(ticket, deduped[existingIndex])) {
      deduped[existingIndex] = ticket;
    }
  });

  return deduped;
}
